module.exports = __webpack_public_path__ + "img/help_fill.074ebab4.png";